import React, { useState } from 'react';
import { Instagram, Facebook, MessageCircle } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';
import { LegalModal } from './LegalModal';
export function Footer() {
  const {
    t
  } = useLanguage();
  const [modalType, setModalType] = useState<'privacy' | 'terms' | null>(null);
  return <>
      <footer className="bg-brand-navy border-t border-white/10 text-white pt-16 pb-8" data-id="element-43">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-44">
          <div className="flex flex-col md:flex-row justify-between items-center md:items-start space-y-8 md:space-y-0 mb-12" data-id="element-45">
            <div className="flex flex-col items-center md:items-start text-center md:text-left" data-id="element-46">
              <img src="https://cdn.magicpatterns.com/uploads/7yPi8SpcWoVCMbepvEjrdt/8F2A0D7B-D6F6-4784-A685-41659FF86BD9.png" alt="K.J Premium Marketing Logo" className="h-36 w-auto object-contain rounded-xl p-2 mb-4" data-id="element-47" />
              <h3 className="text-xl font-bold mb-1" data-id="element-48">
                K.J Premium Marketing LLC
              </h3>
              <p className="text-base text-gray-400" data-id="element-49">{t('footer.subtitle')}</p>
            </div>

            <div className="flex flex-col items-center md:items-end space-y-4" data-id="element-50">
              <a href="https://wa.me/12013540888" target="_blank" rel="noopener noreferrer" className="flex items-center space-x-2 text-brand-accent hover:text-yellow-300 transition-colors text-lg font-medium" data-id="element-51">
                <MessageCircle className="w-5 h-5" data-id="element-52" />
                <span data-id="element-53">WhatsApp: +1 201 354 0888</span>
              </a>

              <div className="flex space-x-6" data-id="element-54">
                <a href="#" className="flex items-center space-x-2 text-gray-300 hover:text-brand-accent transition-colors" data-id="element-55">
                  <Instagram className="w-5 h-5" data-id="element-56" />
                  <span className="hidden sm:inline" data-id="element-57">@k.jpremiummarketing</span>
                </a>
                <a href="#" className="flex items-center space-x-2 text-gray-300 hover:text-brand-accent transition-colors" data-id="element-58">
                  <Facebook className="w-5 h-5" data-id="element-59" />
                  <span className="hidden sm:inline" data-id="element-60">@k.jpremiummarketing</span>
                </a>
              </div>
            </div>
          </div>

          <div className="border-t border-white/10 pt-8 flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0 text-sm text-gray-400" data-id="element-61">
            <div className="flex space-x-4" data-id="element-62">
              <button onClick={() => setModalType('privacy')} className="cursor-pointer hover:text-white transition-colors underline-offset-2 hover:underline" data-id="element-63">
                {t('footer.privacy')}
              </button>
              <span data-id="element-64">|</span>
              <button onClick={() => setModalType('terms')} className="cursor-pointer hover:text-white transition-colors underline-offset-2 hover:underline" data-id="element-65">
                {t('footer.terms')}
              </button>
            </div>
            <p data-id="element-66">{t('footer.copyright')}</p>
          </div>
        </div>
      </footer>

      <LegalModal type={modalType} onClose={() => setModalType(null)} data-id="element-67" />
    </>;
}